import React from 'react';
import IndustryDetail from './IndustryDetail';

const features = [
  {
    tag: 'Export',
    title: 'Global Market Access',
    desc: 'Direct access to buyers across 12+ countries with established logistics and compliance frameworks.',
  },
  {
    tag: 'Quality',
    title: 'Quality Assurance',
    desc: 'Rigorous quality control processes meeting international standards including FSSAI, APEDA, and ISO certifications.',
  },
  {
    tag: 'Sustainability',
    title: 'Sustainable Sourcing',
    desc: 'Committed to responsible farming practices and sustainable supply chains across all commodities.',
  },
  {
    tag: 'Logistics',
    title: 'End-to-End Logistics',
    desc: 'From farm to port — complete logistics management including warehousing, packaging, and shipping.',
  },
];

const AgroExport: React.FC = () => (
  <IndustryDetail
    breadcrumb="Agro Export"
    title="Ajera Export"
    subtitle="Premium agro products to global markets."
    description="Ajera Export delivers premium agro products to global markets with strong quality, compliance, and sustainability standards. We specialize in sourcing, processing, and exporting a wide range of agricultural commodities."
    features={features}
    accentColor="#2563eb"
  />
);

export default AgroExport;
